import {
    Image,
    ResponsiveImage,
    ResponsiveImagePosition,
    ResponsiveImageSize,
} from '../entities/Media/Media';
import useDeviceWidth from './useDeviceWidth';

// Add possibility to extend to more screen size options
const useResponsiveImages = (images: Image[], responsiveImages: ResponsiveImage[]): ResponsiveImage[] => {
    const { isMobile } = useDeviceWidth();

    if (responsiveImages.length === 0) {
        return images.map(image => ({
            image,
            size: ResponsiveImageSize.desktop,
            position: ResponsiveImagePosition.center,
        }));
    }

    const mobileResponsiveImages = responsiveImages
        .filter(responsiveImage => responsiveImage.size === ResponsiveImageSize.mobile)
        .filter(Boolean) as ResponsiveImage[];

    const desktopResponsiveImages = responsiveImages
        .filter(responsiveImage => responsiveImage.size === ResponsiveImageSize.desktop)
        .filter(Boolean) as ResponsiveImage[];

    if (isMobile) {
        return mobileResponsiveImages.length > 0
            ? mobileResponsiveImages
            : desktopResponsiveImages;
    }

    return desktopResponsiveImages.length > 0
        ? desktopResponsiveImages
        : mobileResponsiveImages;
};

export default useResponsiveImages;
